const state = {
    invite: "",
}

const mutations = {
    SET_INVITE(state, payload) {
        state.invite = payload
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
};